import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

@Pipe({
  name: 'formatDateTime'
})
export class FormatDateTimePipe implements PipeTransform {
  transform(date: any, args?: any): any {
    const dateTime = new Date(date)

    if (args == null)
      return moment(dateTime).format('DD.MM.YYYY HH:mm')

    return moment(dateTime).format(args)
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/pipes/formatDateTime.pipe.ts